import { Button, Group, Skeleton, Stack, Text } from '@mantine/core';

interface PagedQueryLike {
  data: { items: unknown[]; total: number } | undefined;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  fetchNextPage: () => unknown;
}

/** "Showing 50 of 1,204 programmes". */
export function ListCount({
  shown,
  total,
  noun,
}: {
  shown: number;
  total: number;
  /** Plural noun, e.g. "programmes". */
  noun: string;
}) {
  return (
    <Text size="sm" c="dimmed" role="status">
      Showing {shown.toLocaleString('en-GB')} of {total.toLocaleString('en-GB')} {noun}
    </Text>
  );
}

/** Placeholder rows while a page loads. */
export function RowSkeletons({ rows = 3, height = 36 }: { rows?: number; height?: number }) {
  return (
    <Stack gap={6} aria-busy="true" aria-label="Loading more">
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} height={height} radius="sm" />
      ))}
    </Stack>
  );
}

/** Under a paged list: the count, skeleton rows while the next page loads, and "Load more". */
export function ListFooter({ query, noun }: { query: PagedQueryLike; noun: string }) {
  if (!query.data) return null;
  return (
    <Stack gap="sm" mt="sm">
      {query.isFetchingNextPage && <RowSkeletons />}
      <Group justify="space-between">
        <ListCount shown={query.data.items.length} total={query.data.total} noun={noun} />
        {query.hasNextPage && (
          <Button
            variant="default"
            size="xs"
            loading={query.isFetchingNextPage}
            onClick={() => void query.fetchNextPage()}
          >
            Load more
          </Button>
        )}
      </Group>
    </Stack>
  );
}
